import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="referrals"
export default class extends Controller {

  /*
   * Marks a referral as acknowledged (the recipient has seen it) via an AJAX PATCH request.
   * On success, replaces the "acknowledge" icon with an "unacknowledge" icon in-place so
   * the user can toggle it back without a page reload.
   *
   * We store a reference to `this` (controllerRef) before the AJAX call because inside the
   * success callback, `this` would refer to the XHR object rather than the Stimulus controller.
   * Tooltips are cleared before the request to prevent them from getting stuck open when the
   * icon element is replaced. After swapping the HTML, we reinitialize tooltips on the new
   * element via reloadTooltip() so the "Unacknowledge" tooltip works on the new icon.
   */
  acknowledge(e) {
    let controllerRef = this
    this.clearTooltips()
    e.preventDefault()
    var item = e.currentTarget
    $.ajax({
      type: "PATCH",
      url: "/members/" + item.dataset.id + "/acknowledge",
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {
        if(data.status == 200){
          var html = '<i class="bi bi-check-circle-fill text-success h4 pointer" data-bs-toggle="tooltip" data-bs-title="Unacknowledge Referral" data-id="' + item.dataset.id + '" data-action="click->referrals#unacknowledge"></i>'
          item.parentElement.innerHTML = html
          controllerRef.reloadTooltip()
        } else {
          alert('Error acknowledging referral. Please try again.')
        }
      }
    })
  }

  connect() {
  }

  clearTooltips() {
    $('[data-bs-toggle="tooltip"]').each(function(){
      $(this).tooltip('hide')
    })
  }

  /*
   * Marks a referral as a lost deal after a confirmation prompt. On success, updates the
   * UI in-place by clearing the acknowledge icon and replacing the referral content with
   * a status message — the referral has moved to the "Deals Lost" tab and is no longer
   * shown in the active referrals list.
   *
   * We update two DOM elements by ID: "acknowledge_{id}" (the action icons) and
   * "referral_content_{id}" (the referral details). Clearing both prevents the user from
   * trying to take further actions on a referral that is no longer in the active state.
   * clearTooltips() is called at the end to clean up any open tooltip that may have been
   * on the button that triggered this action.
   */
  dealLost(e) {
    e.preventDefault()
    var item = e.currentTarget

    var ans = confirm("Are you sure you want to mark this deal lost?")
    if(ans){
      $.ajax({
        type: "PATCH",
        url: "/members/" + item.dataset.id + "/deal_lost",
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
        success: function(data) {
          if(data.status == 200) {
            document.getElementById("acknowledge_" + data.id).innerHTML = ""
            document.getElementById("referral_content_" + data.id).innerHTML = "Referral has been moved to \"Deals Lost\" tab"
          } else {
            alert("Error saving deal status. Please try again.")
          }
        }
      })
    }

    this.clearTooltips()
  }

  /*
   * Submits the "Deal Won" modal form via AJAX. The modal collects the deal amount and
   * closed date, which are included in the PATCH request alongside deal_status=1.
   *
   * We use item.action (the form's action URL) rather than a hardcoded path so this
   * handler works generically for any referral — the server-rendered form already has
   * the correct URL with the referral ID baked in.
   * On success, we clear the referral's action icons and content area (same pattern as
   * dealLost) and programmatically click the modal close button to dismiss it. This
   * avoids needing to know the Bootstrap modal instance reference from within the callback.
   */
  dealWon(e) {
    e.preventDefault()
    var item = e.currentTarget

    $.ajax({
      type: "PATCH",
      url: item.action,
      data: {
        referral: {
          deal_status: 1,
          deal_amount: $('#referral_deal_amount').val(),
          deal_closed: $('#referral_deal_closed').val()
        }
      },
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {

        if(data.status == 200) {
          document.getElementById("acknowledge_" + data.id).innerHTML = ""
          document.getElementById("referral_content_" + data.id).innerHTML = "Referral has been moved to \"Deals Won\" tab"
          $('#close-modal-btn').click()
        } else {
          alert("Error saving deal status. Please try again.")
        }
      }
    })
  }

  reloadTooltip(){
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })
  }


  /*
   * Reverses an acknowledgement, marking the referral as unacknowledged (the recipient
   * "un-sees" it, putting it back in the notification state). Mirrors acknowledge() in
   * structure: clears tooltips, fires a PATCH, then swaps the icon back to the
   * "acknowledge" state with the original exclamation icon.
   *
   * controllerRef stores `this` before the callback for the same reason as in acknowledge() —
   * jQuery callbacks lose the Stimulus controller context. After swapping the HTML, tooltips
   * are reinitialized so the "Acknowledge Referral" tooltip works on the restored icon.
   */
  unacknowledge(e) {
    let controllerRef = this
    this.clearTooltips()
    e.preventDefault()
    var item = e.currentTarget
    $.ajax({
      type: "PATCH",
      url: "/members/" + item.dataset.id + "/unacknowledge",
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {
        if(data.status == 200){
          var html = '<i class="bi bi-exclamation-circle text-info h4 pointer" data-bs-toggle="tooltip" data-bs-title="Acknowledge Referral" data-id="' + item.dataset.id + '" data-action="click->referrals#acknowledge"></i>'
          item.parentElement.innerHTML = html
          controllerRef.reloadTooltip()
        } else {
          alert('Error unacknowledgeing referral. Please try again.')
        }
      }
    })
  }
}
